import React from 'react'
import { cmToIn } from '@helpers/utils'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'

type SizeChartTableProps = {
  sizeChartColumn: string[]
  sizeChartBuild: string[][]
  measurementType: number
}

const SizeChartTable = ({
  sizeChartColumn,
  sizeChartBuild,
  measurementType
}: SizeChartTableProps) => {
  return (
    <div className={styles.sizeChart__tableWrapper}>
      <table className={styles.sizeChart__table}>
        <tbody>
          <tr className={styles.sizeChart__row}>
            {sizeChartColumn.map((columnValue, i) => (
              <th
                key={`column-${i}`}
                className={styles.sizeChart__cell}
                scope={`${i === 0 ? 'col' : 'row'}`}
              >
                {columnValue}
              </th>
            ))}
          </tr>
          {sizeChartBuild.map((rowValue: string[], rowIndex: number) => {
            const legText = Translations.localise('pages.size-chart.table.leg')
            if (
              ['3/" LEG', '5/" LEG', '7/" LEG', '9/" LEG', '11/" LEG'].includes(
                rowValue[0]
              )
            ) {
              return (
                <tr key={rowValue[0]} className={styles.sizeChart__row_title}>
                  <th colSpan={sizeChartColumn.length}>
                    {rowValue[0].replace('/', '').replace('LEG', legText)}
                  </th>
                </tr>
              )
            }
            return (
              <tr key={`sz${rowIndex}`} className={styles.sizeChart__row}>
                {rowValue.map((columnValue: string, columnIndex: number) => (
                  <th
                    key={`column-${columnIndex}`}
                    className={styles.sizeChart__cell}
                    scope={`${columnIndex === 0 ? 'col' : 'row'}`}
                  >
                    {columnIndex !== 0 &&
                    measurementType === 2 &&
                    !isNaN(Number(columnValue))
                      ? cmToIn(Number(columnValue))
                      : columnValue}
                  </th>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default SizeChartTable
